import React from 'react';
import { heroStats } from '../data/mock';
import { useT } from '../i18n/LanguageContext';

const Hero = () => {
  const { t } = useT();

  return (
    <section
      id="home"
      className="relative min-h-[100vh] flex items-end overflow-hidden"
    >
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src="/videos/gpevideo.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0b1c3a]/60 via-[#0b1c3a]/40 to-[#0b1c3a]/85" />

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pb-16 pt-40 w-full">

        {/* Badge */}
        <div className="inline-block px-3 py-1 rounded-full bg-white/10 backdrop-blur border border-white/20 text-white/90 text-[11px] tracking-[0.25em] font-semibold mb-6">
          {t.hero.pill}
        </div>

        {/* Title */}
        <h1 className="text-white font-black leading-[1.02] tracking-tight text-4xl sm:text-5xl lg:text-7xl max-w-4xl">
          {t.hero.titleA}{' '}
          <br className="hidden md:block" />

          <span className="text-[#f5c518]">
            {t.hero.titleAccent}
          </span>{' '}

          {t.hero.titleB}
        </h1>

        {/* Description */}
        <p className="mt-6 text-white/85 text-base md:text-lg max-w-2xl leading-relaxed">
          {t.hero.subtitle}
        </p>

        {/* Buttons */}
        <div className="mt-8 flex flex-wrap gap-3">

          {/* Contact - Separate Page */}
          <a
            href="/contact"
            className="px-6 py-3 rounded-full bg-[#0b3b8c] text-white font-semibold text-sm hover:bg-[#082e6f] transition-colors shadow-lg shadow-blue-900/30"
          >
            {t.hero.ctaContact}
          </a>

          {/* Services - Separate Page */}
          <a
            href="/services"
            className="px-6 py-3 rounded-full bg-white/10 backdrop-blur text-white font-semibold text-sm hover:bg-white/20 transition-colors border border-white/25"
          >
            {t.hero.ctaServices}
          </a>

        </div>

        {/* Stats */}
        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-10 border-t border-white/15 pt-8">

          {t.hero.stats.map((s) => (
            <div key={s.label}>

              <div className="text-white font-black text-3xl md:text-4xl tracking-tight">
                {s.value}
              </div>

              <div className="text-white/70 text-xs md:text-sm mt-1">
                {s.label}
              </div>

            </div>
          ))}

        </div>

      </div>
    </section>
  );
};

export default Hero;